/**
 * Enum du type de message du cadre "Informations" du Dashboard
 */
export enum TypeMessage {
    INFORMATION = 1,
    CONFIRMATION = 2,
    AVERTISSEMENT = 3,
    ALERTE = 4
}